interface KeycloakConfig {
  url: string;
  realm: string;
  clientId: string;
}

const getKeycloakConfig = (): KeycloakConfig => {
  return {
    url: import.meta.env.VITE_KEYCLOAK_URL || 'http://localhost:8080/giro/api/v1/auth/login',
    realm: import.meta.env.VITE_KEYCLOAK_REALM || 'giro-suite',
    clientId: import.meta.env.VITE_KEYCLOAK_CLIENT_ID || 'giro-connect'
  };
};

export const redirectToKeycloakLogin = () => {
  const config = getKeycloakConfig();

  window.location.href = `${config.url}`;
};

